import { Link, useLocation } from "react-router-dom";
import Seo from "@/components/Seo";

const NAV = [
  { label: "Home", to: "/" },
  { label: "The codelumen System", to: "/system" },
  { label: "Capabilities", to: "/solutions" },
  { label: "Selected Projects", to: "/work" },
  { label: "codelumenLabs", to: "/labs" },
  { label: "Contact", to: "/contact" },
];

const NotFound = () => {
  const location = useLocation();

  return (
    <>
      <Seo
        title="Page not found | codelumen"
        description="The page you were looking for is not here. Return to the codelumen system, selected projects, or contact."
        path={location.pathname}
        noindex
      />
      <main className="cl-section-deep min-h-screen flex items-center pt-32 md:pt-40 pb-24 md:pb-32">
        <div className="cl-grid w-full">
          <p className="cl-eyebrow opacity-50">Error · 404</p>

          <h1
            className="font-sans font-light tracking-[-0.025em] leading-[1.02] mt-8 max-w-4xl text-[clamp(2.5rem,6vw,5.25rem)]"
          >
            The page you were looking for
            <br />
            <span className="opacity-60">is not here.</span>
          </h1>

          <div
            aria-hidden
            className="h-px w-24 bg-current/25 mt-10"
          />

          <p className="cl-body opacity-70 max-w-2xl mt-10">
            The link may be outdated or the page may have moved as the codelumen site evolved. Continue from one of the entry points below.
          </p>

          <nav aria-label="Primary navigation" className="mt-14">
            <ul className="grid grid-cols-1 sm:grid-cols-2 max-w-2xl border-t border-current/10">
              {NAV.map((n) => (
                <li key={n.to} className="border-b border-current/10">
                  <Link
                    to={n.to}
                    className="group flex items-baseline justify-between py-5 md:py-6 pr-2 font-sans font-light text-lg md:text-xl tracking-[-0.005em] opacity-80 hover:opacity-100 transition-opacity"
                  >
                    <span>{n.label}</span>
                    <span
                      aria-hidden
                      className="ml-4 opacity-40 group-hover:opacity-100 group-hover:translate-x-1 transition-all"
                    >
                      ›
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <p className="mt-14 font-sans font-light text-[10px] tracking-[0.24em] uppercase opacity-40">
            requested · {location.pathname}
          </p>
        </div>
      </main>
    </>
  );
};

export default NotFound;
